import moment from 'moment'

export default (date) => {
	const timeZone = new Date().getTimezoneOffset();

	return moment(String(date)).add((timeZone / 60) * -1, 'hours').format();
}

